import { c as _c } from "react/compiler-runtime";
import Link from "next/link";

// interface for an individual link item
interface SecondaryLink {
  label: string;
  href: string;
  isBold?: boolean; // For Case Studies
  isSmall?: boolean; // For Other Links
}
//  main Props interface for the section
interface SecondaryNavSectionProps {
  title: string;
  links: SecondaryLink[];
  onClose: () => void;
}
const SecondaryNavSection = t0 => {
  const $ = _c(12);
  const {
    title,
    links,
    onClose
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h3 className="text-black/80 text-xs uppercase tracking-widest mb-6 border-b border-black/10 pb-2">{title}</h3>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== links || $[3] !== onClose) {
    let t3;
    if ($[5] !== onClose) {
      t3 = link => <Link key={link.label} href={link.href} onClick={onClose} className={`${link.isBold ? "text-xl" : "text-md tracking-widest"} hover:text-primary flex items-center gap-2 text-accent-foreground font-semibold transition-all duration-500 capitalize`}>{link.label}{!link.isBold && <span className="opacity-40">→</span>}</Link>;
      $[5] = onClose;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = links.map(t3);
    $[2] = links;
    $[3] = onClose;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <div className="flex flex-col gap-4">{t2}</div>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t3) {
    t4 = <div className="mb-16">{t1}{t3}</div>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export default SecondaryNavSection;